import React, {useState} from 'react';
import Header from "../../components/Header";
import Hero from '../../components/Hero';
import Slideshow from '../../components/Slide';
import Anuncio from '../../components/Anuncio';
import NewGrid from '../../components/NewGrid';
import Footer from '../../components/Footer';
import styled from 'styled-components';
import api from '../../services/api';
import destaque from '../../img/destaque_02.jpg';

const Div = styled.div`
  a{
    backgroun-color: white;
  }
  #l1{
    background-color: #095EB2;
    color: white;
  }
  .sepe{
    width: 86%; 
    height: 300px;
    margin-left: 7%;
    background-color: #C4C4C4;
    cursor: 'pointer';
  }
`;
const items = [
    {
    "img": "slideshow.jpg",
    "titulo": "Homologação e Reconhecimento de Estudos Superiores",
    "conteudo": "Já não precisa se deslocar para obter a sua declaração, homologação ou reconhecimento",
    "id": "1"
    },
    {
    "img": "slideshow-2.png",
    "titulo": "Homologação e Reconhecimento de Estudos Superiores",
    "conteudo": "Já não precisa se deslocar para obter a sua declaração, homologação ou reconhecimento",
    "id": "2"
    }
]
export default class Home extends React.Component{

  state = {
    hero: [],
    anuncio: {},
    sepe: {},
    homologacao: [],
    reconhecimento: [],
  }
  componentDidMount(){
    this.heroLoad();
    this.anuncioLoad();
    this.homologacaoLoad();
  }

  heroLoad = async () =>{
    const res = await api.get('/banner');
    
    this.setState({hero: res.data});
  }

  anuncioLoad = async () =>{
    const res = await api.get('/anuncio');
    console.log(res)
    this.setState({anuncio: res.data[0], sepe: res.data[1]});
  }

  homologacaoLoad = async () =>{
    const res = await api.get('/categoria/home');
    
    this.setState({homologacao: res.data[0], reconhecimento: res.data[1]});
  }


  render(){
    window.scrollTo(0, 0);
    return (
      <Div className="Home">
          <Header bg='#l1'/>
          <Slideshow dados={this.state.hero} />
          
          <Anuncio dados={this.state.anuncio}/>
          <NewGrid dados={this.state.homologacao}/>
          <NewGrid dados={this.state.reconhecimento}/>
          <div >
              <a href={(this.state.sepe.link)? this.state.sepe.link: '#'} target="_blank"> 
              {this.state.sepe.img &&(
                    <img src={`https://inaarees.gov.ao/backend/u/${this.state.sepe.img}`} className="sepe"/>
                )
              }
              </a>
          </div>
          <Footer />
      </Div>
    );
  }
}

